import initialState from '../initialState.js';
import {
    SET_MASTER_ACCESS,
    GET_MASTER_SUCCESS,
    GET_MASTER_USERS_SUCCESS,
    UPDATE_MASTER_ACCESS_SUCCESS,
    ADD_MASTER_SUCCESS,
    REMOVE_MASTER_SUCCESS,
    CREATE_BROKERAGE_SUCCESS,
    UPDATE_MASTER_STATUS
} from '../../actions/types/master';

export default (state = initialState.master, action) => {
    switch (action.type) {
        case SET_MASTER_ACCESS: {
            return {
                ...state,
                access: action.access
            };
        }

        case GET_MASTER_SUCCESS: {
            return {
                ...state,
                ...action.data
            };
        }

        case GET_MASTER_USERS_SUCCESS: {
            return {
                ...state,
                users: action.data
            };
        }

        case UPDATE_MASTER_STATUS: {
            return {
                ...state,
                status: action.status
            };
        }

        case ADD_MASTER_SUCCESS: {
            return {
                ...state,
                users: [ ...state.users, action.data ]
            };
        }

        case UPDATE_MASTER_ACCESS_SUCCESS: {
            return {
                ...state,
                users: state.users.map((user) => {
                    if (user.masterID === action.masterID) {
                        return {
                            access: action.access,
                            email: user.email,
                            firstname: user.firstname,
                            lastname: user.lastname,
                            masterID: user.masterID
                        };
                    }

                    return user;
                })
            };
        }

        case REMOVE_MASTER_SUCCESS: {
            return {
                ...state,
                users: state.users.filter((user) => user.masterID !== action.masterID)
            };
        }

        case CREATE_BROKERAGE_SUCCESS: {
            return {
                ...state,
                brokerages: [ ...state.brokerages, action.brokerage ]
            };
        }

        default:
            return state;
    }
};